import { render } from "./ClubDealOpenModal.vue?vue&type=template&id=a8998374&scoped=true&ts=true"
import script from "./ClubDealOpenModal.vue?vue&type=script&lang=ts"
export * from "./ClubDealOpenModal.vue?vue&type=script&lang=ts"

import "./ClubDealOpenModal.vue?vue&type=style&index=0&id=a8998374&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8998374"]])

export default __exports__